import * as R from 'ramda';
import type { RecordType } from './types/record';

function shuffle(array: any[]) {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

export function videoAdaptor(list: Record<string, any>[]) {
  const result = shuffle(list.map((r) => ({ ...r })));
  console.log(result);

  return R.pipe<Record<string, any>[], Record<string, any>, RecordType[]>(
    R.filter((record: Record<string, any>) => !!record.image && !!record.video),
    R.addIndex(R.map)((record: Record<string, any>, index) => {
      const {
        desc: description,
        end_time: end,
        image: thumbnail,
        keyword,
        question,
        start_time: start,
        video,
        product = {},
      } = record;

      // 9:16 샘플 비디오 및 이미지
      // const video =
      //   'https://videos.pexels.com/video-files/15465878/15465878-hd_1080_1920_30fps.mp4';
      // const thumbnail =
      //   'https://images.unsplash.com/photo-1604311795833-25e1d5c128c6?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8OSUzQTE2fGVufDB8fDB8fHww';
      return {
        id: index,
        description,
        thumbnail,
        subject: keyword,
        media: [{ id: 0, url: video, mime: '' }],
        properties: {
          question: { label: '질문', value: question },
          marker: {
            label: '영상마커',
            value: [
              { label: '시작점', value: start },
              { label: '끝지점', value: end },
            ],
          },
          product: {
            label: '상품정보',
            value: product,
          },
        },
      } as RecordType;
    })
  )(result);
}
